/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

export default class SlotEditorStateAPI {

	/**
	 * @function SlotEditorStateAPI#getModel
	 * @description get the intance of SlotEditorModel
	 * @return {SlotEditorModel} the intance of SlotEditorModel
	 */
	getModel() {}

	/**
	 * @function SlotEditorStateAPI#getProviderId
	 * @description get slot editor provider id
	 * @return {String} the provider id
	 */
	getProviderId() {}
}


// WEBPACK FOOTER //
// ./src/js/dashboard/SlotEditorStateAPI.js